<div
  class="terminal-metrics-wrapper ioh-equipment-info"
  [style.left.px]="left"
  [style.z-index]="zIndex"
  [id]="terminalUid"
>
  <div class="terminal-metrics">
    <div class="flex align-items-center justify-content-between gap-20">
      <div class="terminal-name-abbrevation-container">
        <div class="text-style">
          <strong class="text-style"> Equipment </strong>
        </div>
      </div>

      <div class="close-button" (click)="closeClicked()">X</div>
    </div>
    <div>
      <div class="flex gap-2">
        <div
          class="cumlative-equipment-info flex justify-content-center align-items-center gap-2"
        >
          <p-badge
            badgeSize="small"
            value="&nbsp;"
            severity="success"
            class="br-4"
          ></p-badge>
          <span class="ioh-text-white"> Active </span>
        </div>
        <div
          class="cumlative-equipment-info flex justify-content-center align-items-center gap-2"
        >
          <p-badge badgeSize="small" value="&nbsp;" class="br-4" severity="warn"></p-badge>
          <span class="ioh-text-white"> Idle </span>
        </div>
        <div
          class="cumlative-equipment-info flex justify-content-center align-items-center gap-2"
        >
          <p-badge class="br-4" badgeSize="small" value="&nbsp;" severity="danger"></p-badge>
          <span class="ioh-text-white"> Offline </span>
        </div>
      </div>
    </div>
    <csx-ioh-equipment-info-table
      [columns]="equipmentInfoTableColumns"
      [dataTable]="displayEquipmentInfoTableData"
    ></csx-ioh-equipment-info-table>
  </div>
</div>
